import { LazyQueryResultTuple, useLazyQuery } from '@apollo/client';
import { UserArticleRelation } from 't2-graphql-types';
import { useEffect } from 'react';
import { getUserArticleRelationsOfTypeInspire } from '../queries/getUserArticleRelationsOfTypeInspire';

type TQueryReturnValue = {
  userArticleRelations: UserArticleRelation[];
};

type THookProps = { articleId: string; userId: string | undefined };

type TQueryArgs = THookProps;

type TReturnValue = LazyQueryResultTuple<TQueryReturnValue, TQueryArgs>;

export const useIsInspiredByArticle = ({ articleId, userId }: THookProps): TReturnValue => {
  const [fetchIsInspiredByArticle, queryResult] = useLazyQuery<TQueryReturnValue, TQueryArgs>(
    getUserArticleRelationsOfTypeInspire,
    {
      variables: {
        articleId,
        userId,
      },
    },
  );
  const { loading, error } = queryResult;

  useEffect(() => {
    if (!loading && !error && userId) {
      fetchIsInspiredByArticle();
    }
  }, [loading, error, userId]);

  return [fetchIsInspiredByArticle, queryResult];
};
